import * as log from 'loglevel';

export const getLocalStorageItem = (key) => {
  try {
    return typeof localStorage !== 'undefined' && localStorage.getItem(key);
  } catch (e) {
    log.debug(e);
    return null;
  }
};

export const setLocalStorageItem = (key, value) => {
  try {
    typeof localStorage !== 'undefined' && localStorage.setItem(key, value);
  } catch (e) {
    log.debug(e);
  }
};



// WEBPACK FOOTER //
// ./src/utils/localStorage.js